module.exports = global["Player"] = require("-!/home/player/releases/player-master-77f9abc9c2798b7a9c7678214dd3cf55db3285b6-32/node_modules/babel-loader/lib/index.js!/home/player/releases/player-master-77f9abc9c2798b7a9c7678214dd3cf55db3285b6-32/node_modules/string-replace-webpack-plugin/loader.js?id=h3ar9zpbxze!./player.js");


//////////////////
// WEBPACK FOOTER
// ./src/player.js
// module id = RQgh
// module chunks = 0